import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {AccordionModule,} from 'primeng/accordion';
import {AutoCompleteModule,} from 'primeng/autocomplete';
import {CheckboxModule,} from 'primeng/checkbox';
import {PanelModule,} from 'primeng/panel';
import {SharedModule as PNGSharedModule} from 'primeng/api';
import {ClinicalTrialsComponent} from '@ispm/therapies/components/clinical-trials/clinical-trials.component';
import {DrugListComponent} from '@ispm/therapies/components/drug-list/drug-list.component';
import {ManualCurationConfirmationComponent} from '@ispm/therapies/components/manual-curation-confirmation/manual-curation-confirmation.component';
import {TherapiesListComponent} from '@ispm/therapies/components/therapies-list/therapies-list.component';
import {TherapyCardComponent} from '@ispm/therapies/components/therapy-card/therapy-card.component';
import {TherapyTierComponent} from '@ispm/therapies/components/therapy-tier/therapy-tier.component';
import {TherapyTitleElementComponent} from '@ispm/therapies/components/therapy-title-element/therapy-title-element.component';
import {TherapiesActionCreatorService} from '@ispm/therapies/services/therapies-action-creator.service';
import {TherapiesService} from '@ispm/therapies/services/therapies.service';
import {DynamicFormModule} from '@ispm/dynamic-form/dynamic-form.module';
import {SharedModule} from '@ispm/shared/shared.module';
import {CoreModule} from '@ispm/core/core.module';
import {TherapyPrioritizeComponent} from '@ispm/therapies/components/therapy-prioritize/therapy-prioritize.component';
import {TestModule} from '@ispm/test/test.module';
import {UserModule} from '../user/user.module';
import {TreatmentsComponent} from './components/treatments/treatments.component';
import {StoreModule} from '@ngrx/store';
import {therapiesReducer} from '@ispm/therapies/store/therapies.reducer';
import {LayoutModule} from '@ispm/layout/layout.module';
import {PrioritizationConfigurationAdapter} from '@ispm/therapies/classes/prioritization-configuration.adapter';
import {WidgetsModule} from '@ispm/widgets/widgets.module';
import {PathwaySelectionsModule} from '@ispm-client/modules/pathway-selections/pathway-selections.module';
import {SelectableModalComponent} from './components/selectable-modal/selectable-modal.component';
import {EditTherapyModalComponent} from '@ispm/therapies/components/edit-therapy-modal/edit-therapy-modal.component';
import {ButtonClickPermissionDirective} from '@ispm/therapies/directives/buttonClickPermission.directive';
import {EffectsModule} from '@ngrx/effects';
import {TherapiesEffect} from '@ispm/therapies/store/therapies.effects';
import {PanelServiceWrapper} from '@ispm/shared/services/panel-service-wrapper.service';
import {OffPathwayComponent} from '@ispm/therapies/components/off-pathway/off-pathway.component';
import {ExpandableInformationCardComponent} from './components/expandable-information-card/expandable-information-card.component';
import {ExpandableInformationCardWrapperComponent} from './components/expandable-information-card-wrapper/expandable-information-card-wrapper.component';
import {TreatmentSelectionService} from './services/treatment-selection.service';
import {RecommendationTargetGeneticsComponent} from './components/treatment-information/recommendation-target-genetics/recommendation-target-genetics.component';
import {TableModule} from 'primeng/table';
import {TreatmentPlansSelectionModalComponent} from "@ispm/therapies/components/treatment-plans-selection-modal/treatment-plans-selection-modal.component";
import {PaginatorModule} from "primeng/paginator";
import { TherapiesSelectionComponent } from './components/therapies-selection/therapies-selection.component';
import { TreatmentSubjectWrapperComponent } from './components/treatment-subject-wrapper/treatment-subject-wrapper.component';
import { SubjectListRowComponent } from './components/treatment-subject-list/subject-list-row/subject-list-row.component';
import { SubjectListCellComponent } from './components/treatment-subject-list/subject-list-cell/subject-list-cell.component';
import { TreatmentSelectionComponent } from './components/treatment-selection/treatment-selection.component';
import { TreatmentSummaryComponent } from './components/treatment-summary/treatment-summary.component';
import { InformationCardComponent } from './components/information-card/information-card.component';
import { TreatmentInformationWrapperComponent } from './components/treatment-information-wrapper/treatment-information-wrapper.component';
import { TreatmentSubjectListComponent } from './components/treatment-subject-list/treatment-subject-list.component';
import { TreatmentOptionComponent } from './components/treatment-option/treatment-option.component';
import { TreatmentSubjectComponent } from './components/treatment-subject/treatment-subject.component';
import { TherapiesAddNewComponent } from './components/therapies-add-new/therapies-add-new.component';
import { TreatmentViewComponent } from './components/treatment-view/treatment-view.component';
import { TreatmentInformationComponent } from './components/treatment-information/treatment-information.component';
import { ReportPreviewComponent } from "@ispm/therapies/components/report-preview/report-preview.component";
import { ReleaseReportComponent } from "@ispm/therapies/components/report-preview/release-report/release-report.component";
import { TherapyMatchComponent } from "@ispm/migration/components/therapyMatch/therapy-match.component";
import {VScrollerComponent} from "@ispm/therapies/components/treatment-subject-list/v-scroller/v-scroller.component";
import { ReleaseWarningComponent } from './components/report-preview/release-warning/release-warning.component';

@NgModule({
  imports: [
    CoreModule,
    DynamicFormModule,
    SharedModule,
    LayoutModule,
    TestModule,
    FormsModule,
    CheckboxModule,
    PNGSharedModule,
    WidgetsModule,
    AutoCompleteModule,
    AccordionModule,
    TableModule,
    PaginatorModule,
    PanelModule,
    UserModule,
    StoreModule.forFeature('therapyMatch', therapiesReducer),
    PathwaySelectionsModule,
    EffectsModule.forFeature([TherapiesEffect])
  ],
  declarations: [
    ClinicalTrialsComponent,
    DrugListComponent,
    ManualCurationConfirmationComponent,
    TherapiesAddNewComponent,
    TherapiesListComponent,
    TherapiesSelectionComponent,
    TherapyCardComponent,
    TherapyPrioritizeComponent,
    TherapyTierComponent,
    TherapyTitleElementComponent,
    TreatmentsComponent,
    TreatmentViewComponent,
    TreatmentInformationComponent,
    TreatmentOptionComponent,
    TreatmentSubjectComponent,
    TreatmentSubjectListComponent,
    TreatmentInformationWrapperComponent,
    InformationCardComponent,
    ExpandableInformationCardComponent,
    ExpandableInformationCardWrapperComponent,
    TreatmentSelectionComponent,
    TreatmentSummaryComponent,
    EditTherapyModalComponent,
    SelectableModalComponent,
    SubjectListRowComponent,
    SubjectListCellComponent,
    SelectableModalComponent,
    ButtonClickPermissionDirective,
    OffPathwayComponent,
    TreatmentSubjectWrapperComponent,
    RecommendationTargetGeneticsComponent,
    TreatmentPlansSelectionModalComponent,
    TherapyMatchComponent,
    ReportPreviewComponent,
    ReleaseReportComponent,
    VScrollerComponent,
    ReleaseWarningComponent
  ],
  providers: [
    TherapiesActionCreatorService,
    TherapiesService,
    PrioritizationConfigurationAdapter,
    PanelServiceWrapper,
    TreatmentSelectionService
  ],
  exports: [TherapyPrioritizeComponent, TherapiesSelectionComponent]
})
export class TherapiesModule {
}
